import { Autocomplete, TextField, Box } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";

export default class PeriodoSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            loading: false,
        }
    }

    componentDidMount() {
        this.carregarPeriodos();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.unidadeId !== this.props.unidadeId) {
            this.carregarPeriodos();
        }
    }

    carregarPeriodos() {
        if (!this.props.unidadeId) {
            this.setState({ items: [] });
            if (this.props.onChange) this.props.onChange(null);
            return;
        }

        this.setState({ loading: true });
        httpGet('/apuracao/periodos/' + this.props.unidadeId,
            data => {
                let periodos = data.periodos;
                console.log(periodos);
                if (this.props.all) {
                    periodos.unshift({ nome: 'Todos os períodos' });
                }
                this.setState({
                    items: periodos,
                    loading: false
                });
                if (this.props.onChange)
                    this.props.onChange(this.props.all ? periodos[0] : null);
            },

            error => {
                console.log(error);
                this.setState({ loading: false });
            },

            true //salva no cache
        );
    }

    render() {
        return (
            <Autocomplete {...this.props.props}
                noOptionsText="Nenhum período encontrado"
                loadingText="Carregando..."
                openText="Abrir lista"
                loading={this.state.loading}
                disabled={this.props.disabled}
                value={this.props.value} options={this.state.items}
                size="small"
                sx={{
                    ...this.props.sx,
                    // '& fieldset': { borderRadius: 10 }, borderRadius: 10
                }}
                getOptionLabel={option => option.nome}
                getOptionKey={option => option.uuid}
                onChange={(e, value) => this.props.onChange ? this.props.onChange(value) : {}}
                isOptionEqualToValue={(option, value) => { return option.uuid === value.uuid }}
                renderOption={({ key, ...optionProps }, option) => (
                    <Box component="li" key={key} {...optionProps} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {option.apurado !== undefined && (
                            <Box
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: '50%',
                                    backgroundColor: option.apurado ? 'success.main' : 'grey.400',
                                    flexShrink: 0,
                                }}
                            />
                        )}
                        {option.nome}
                    </Box>
                )}
                renderInput={(params) => <TextField
                    {...params}
                    error={this.props.error === true}
                    helperText={this.props.error === true ? "Selecione um período" : null}
                    label={'Período' + (this.props.required ? '*' : '')} />}
            />
        );
    }
}